import { gql, TypedDocumentNode } from '@apollo/client';

export type CreateApplePayMerchantSessionMutationVariables = {
  input: {
    url: string;
  };
};

export type ApplePayMerchantSession = {
  epochTimestamp: number;
  expiresAt: number;
  merchantSessionIdentifier: string;
  nonce: string;
  domainName: string;
  displayName: string;
  signature: string;
};

export type CreateApplePayMerchantSessionMutation = {
  applePayMerchantSession: ApplePayMerchantSession;
};

export const CREATE_APPLE_PAY_MERCHANT_SESSION: TypedDocumentNode<
  CreateApplePayMerchantSessionMutation,
  CreateApplePayMerchantSessionMutationVariables
> = gql`
  mutation CreateApplePayMerchantSession($input: CreateApplePayMerchantSessionMutationInput!) {
    applePayMerchantSession(input: $input)
      @rest(
        type: "RestCreateApplePayMerchantSession"
        endpoint: "self"
        path: "/apple-session"
        method: "POST"
      ) {
      displayName
      domainName
      epochTimestamp
      expiresAt
      merchantIdentifier
      merchantSessionIdentifier
      nonce
      operationalAnalyticsIdentifier
      signature
    }
  }
`;
